module.exports = __webpack_public_path__ + "img/mobile.8fccade8.svg";